import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MenuProvider } from './components/context/MenuContext';
import axios from 'axios';

import './index.css'
import App from './App.jsx'
import './analytics.js'

// Configure axios for cross-origin requests
axios.defaults.withCredentials = false; // Don't send cookies for cross-origin requests

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <MenuProvider>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </MenuProvider>
    </StrictMode>,
)